import React from 'react'
import { getVendorCodes } from '../../api'
import { JsonVendorCode, VendorCode } from '../../models'
import { VendorsTable } from './table'
import { InsufficientPermissions, PaginatedTable, PaginatedTableCallbacks } from '../common'
import defineAbility from './defineAbility'
import { getAuthUser } from '../../helpers'

export const VendorsLanding = () => {
    const ability = defineAbility(getAuthUser())

    if (!ability.can('View', 'Vendor')) {
        return <InsufficientPermissions />
    }

    return (
        <PaginatedTable<VendorCode, JsonVendorCode>
            getData={getVendorCodes}
            redirectLink={{
                to: '/vendors/add',
                text: 'Create Vendor',
            }}
            modelConstructor={(json: JsonVendorCode) => new VendorCode(json)}
            Table={(vendors: VendorCode[], callbacks: PaginatedTableCallbacks) => (
                <VendorsTable callbacks={callbacks} resources={{ vendors }} />
            )}
            searchPlaceholder='Search by Vendor Code'
            title="Vendors"
        />
    )
}
